const styles = {
    img: {
        height: "30px",
        borderRadius: "2px",
    },
};

function Ability({ ability, faction }) {
    const factions = {
        Federation: "Federation",
        "Klingon Empire": "Klingon",
        "Romulan Republic": "Romulan",
        "Cross-Faction": "Federation",
        Dominion: "Dominion",
    };

    const factionName = factions[faction];

    const imgSrc = `https://stowiki.net/wiki/Special:Redirect/file/${ability.img_url}_icon_(${factionName}).png`;

    return (
        <a
            target="_blank"
            href={"https://stowiki.net/wiki/" + ability.url}
            key={ability.id}
            rel="noreferrer"
        >
            <img
                style={styles.img}
                src={imgSrc}
                alt={ability.name}
                title={ability.name}
            />
        </a>
    );
}

export default Ability;
